module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAADQAAAAAubNPtAAAA7ElEQVQoFWOcNWuWDwMDQxYQCwMxPvABKNnIAiSWAXE8CwvLTXyqf//+bQWU72H5//8/Lysr65GkpKTX+DTMnDmTGSifx4RN0ezZs/3nzJljh00OqwagrR7//v1zwKYB5Ac4AFrrzcjIaAYUMAXiz8AAATljX1pa2kGYIhQNTExMfEDThYCYHajxL1ARiM0DUwyiUTSkpqYuB4otB5o8HUg/B5rcBFKEDFA0wCSAph8CmvwOxkemsWqA2oSsDs4GaXjz588frfnz5+ONOJAakK0szMzM5cAgXA6MSRG4MVgYQMWfgGoTsUjhFwIAUjZWNK3A4DAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/卡片开合状态-关.png
// module id = 286
// module chunks = 2